




import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class JsonViewer extends Mixins() {
  @Prop()
  source: string;

  get jsonString(): string {
    return JSON.stringify(this.source, null , "  ");
  }
}
